document.addEventListener("DOMContentLoaded", function () {
    // Check if the grid-col-container exists
    const grid = document.querySelector(".grid-col-container");
    if (grid) {
        const items = grid.querySelectorAll(".grid-col").length;

        // Add necessary divs based on the number of items
        if (items % 3 === 1) {
            grid.innerHTML +=
                '<div style="background:white;grid-column: span 2;"></div>';
        } else if (items % 3 === 2) {
            grid.innerHTML += '<div style="background:white;"></div>';
        }
    }
});
